import { useReveal } from '../hooks/useReveal.js';

/**
 * Fades its child up on first scroll into view. `index` staggers siblings in a
 * grid or row by 70ms apiece, wrapping every four — same cadence the design
 * canvas applied across the whole document.
 */
export default function Reveal({
  as: Tag = 'div',
  index = 0,
  className = '',
  style,
  children,
  ...rest
}) {
  const ref = useReveal();

  return (
    <Tag
      ref={ref}
      className={`reveal ${className}`}
      style={{ '--reveal-delay': `${(index % 4) * 70}ms`, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
